import { render, staticRenderFns } from "./WizardCard.vue?vue&type=template&id=f445303e&scoped=true&"
import script from "./WizardCard.vue?vue&type=script&lang=js&"
export * from "./WizardCard.vue?vue&type=script&lang=js&"
import style0 from "./WizardCard.vue?vue&type=style&index=0&id=f445303e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f445303e",
  null
  
)

export default component.exports